// extracted by mini-css-extract-plugin
export var image = "LogosItem-module--image--243ab";
export var picture = "LogosItem-module--picture--57539";